import { Route, Routes } from 'react-router-dom';

import OtpPageLayout from '../../auth/components/OtpPageLayout';

import { HomePage as Home } from './HomePage';
import { HomeRedirect } from './HomeRedirect';

export const HomePage = () => {
  return (
    <Routes>
      <Route path="/home/" element={<Home />} />
      <Route path="/*" element={<HomeRedirect />} />
      <Route path="/workspace-otp" element={<OtpPageLayout />} />
    </Routes>
  );
};
